/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataEntityField } from '../models/data-entity-field';
import { DataEntityFieldPartialExcludingId } from '../models/data-entity-field-partial-excluding-id';
import { NewDataViewFields } from '../models/new-data-view-fields';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataEntityFieldsControllerService extends DataBaseService {

  /**
   * Path part for operation dataEntityFieldsControllerFindSystemFields
   */
  static readonly DataEntityFieldsControllerFindSystemFieldsPath = '/v1/entities/fields/system';

  /**
   * Get all system fields
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSystemFields()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSystemFields$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntityField>>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerFindSystemFieldsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntityField>>;
      })
    );
  }
  /**
   * Get all system fields
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findSystemFields$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSystemFields(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntityField>> {

    return this.findSystemFields$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntityField>>) => r.body as Array<DataEntityField>)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerCount
   */
  static readonly DataEntityFieldsControllerCountPath = '/v1/entities/{entity}/fields/count';

  /**
   * Get total fields of specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get total fields of specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerFindById
   */
  static readonly DataEntityFieldsControllerFindByIdPath = '/v1/entities/{entity}/fields/{fieldId}';

  /**
   * Get single field of specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataEntityField>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('fieldId', params.fieldId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntityField>;
      })
    );
  }
  /**
   * Get single field of specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataEntityField> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntityField>) => r.body as DataEntityField)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerDeleteById
   */
  static readonly DataEntityFieldsControllerDeleteByIdPath = '/v1/entities/{entity}/fields/{fieldId}';

  /**
   * Delete single field of specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('fieldId', params.fieldId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete single field of specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerUpdateById
   */
  static readonly DataEntityFieldsControllerUpdateByIdPath = '/v1/entities/{entity}/fields/{fieldId}';

  /**
   * Update single field of specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataEntityFieldPartialExcludingId
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('fieldId', params.fieldId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update single field of specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    fieldId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataEntityFieldPartialExcludingId
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerFind
   */
  static readonly DataEntityFieldsControllerFindPath = '/v1/entities/{entity}/fields';

  /**
   * Get all fields of specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataEntityField>>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataEntityField>>;
      })
    );
  }
  /**
   * Get all fields of specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataEntityField>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataEntityField>>) => r.body as Array<DataEntityField>)
    );
  }

  /**
   * Path part for operation dataEntityFieldsControllerCreate
   */
  static readonly DataEntityFieldsControllerCreatePath = '/v1/entities/{entity}/fields';

  /**
   * Add field to specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataViewFields
  }): Observable<StrictHttpResponse<DataEntityField>> {

    const rb = new RequestBuilder(this.rootUrl, DataEntityFieldsControllerService.DataEntityFieldsControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataEntityField>;
      })
    );
  }
  /**
   * Add field to specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataViewFields
  }): Observable<DataEntityField> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataEntityField>) => r.body as DataEntityField)
    );
  }

}
